import { render, staticRenderFns } from "./PlugIn.vue?vue&type=template&id=22f688d4&scoped=true&"
import script from "./PlugIn.vue?vue&type=script&lang=js&"
export * from "./PlugIn.vue?vue&type=script&lang=js&"
import style0 from "./PlugIn.vue?vue&type=style&index=0&id=22f688d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f688d4",
  null
  
)

export default component.exports